export default "__VITE_ASSET__DmNcgj$V__"